/**
 * Pagination Component
 * 공통 페이지네이션 컴포넌트
 */
import React from 'react';
import './Pagination.css';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    maxPagesToShow?: number;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onPageChange,
    maxPagesToShow = 5
}) => {
    // 페이지 번호 목록 생성
    const getPageNumbers = () => {
        const pages = [];

        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        if (endPage - startPage < maxPagesToShow - 1) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    if (totalPages <= 1) {
        return null;
    }

    return (
        <div className="pagination-container">
            <button
                className="pagination-btn"
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
                title="첫 페이지"
            >
                <i className="fas fa-angle-double-left"></i>
            </button>
            <button
                className="pagination-btn"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                title="이전 페이지"
            >
                <i className="fas fa-angle-left"></i>
            </button>

            {getPageNumbers().map(page => (
                <button
                    key={page}
                    className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </button>
            ))}

            <button
                className="pagination-btn"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                title="다음 페이지"
            >
                <i className="fas fa-angle-right"></i>
            </button>
            <button
                className="pagination-btn"
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
                title="마지막 페이지"
            >
                <i className="fas fa-angle-double-right"></i>
            </button>
        </div>
    );
};

export default Pagination;
